import { render, staticRenderFns } from "./VoucherBalance.vue?vue&type=template&id=35262b39&scoped=true&"
import script from "./VoucherBalance.vue?vue&type=script&lang=js&"
export * from "./VoucherBalance.vue?vue&type=script&lang=js&"
import style0 from "./VoucherBalance.vue?vue&type=style&index=0&id=35262b39&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35262b39",
  null
  
)

export default component.exports